import React, { useState, useEffect } from 'react';
import Theme from './Theme';
import EngagementGauge from './EngagementGauge';
import OpportunityGauge from './OpportunityGauge';

import { FaSearch } from 'react-icons/fa';
import { Row, Column } from 'react-foundation';

import SponsorPulseLogo from '../../../../../../assets/images/sponsorpulse-logo.png';
import { months } from '../../../../utils/contants';

const ThemesTab = (props) => {
	useEffect(() => {
		requestSort('engagement_score');
	}, []);

	const [curTheme, setTheme] = useState({
		id: -1,
		engagement_score: 0,
		opportunity_score: 0,
	});
	const [searchTerm, setSearchTerm] = useState('');
	const [themeSet, setThemeSet] = useState(
		props.theme_sets[Object.keys(props.theme_sets)[0]]
	);
	const gaugeColors = ['#6351FB', '#FF9A02', '#28AD25']; // purple,orange,green
	// this is used to determine gauge position on mobile
	var curThemeRendered = false;
	const dateToStr = (date) => {
		return months[parseInt(date.slice(5, 7)) - 1] + ' ' + date.slice(0, 4);
	};

	const changeSearchTerm = (newTerm) => {
		setSearchTerm(newTerm);
	};

	const changeThemeSet = (event) => {
		setThemeSet(props.theme_sets[event.target.value]);
	};

	const useSortableData = (sortedThemes, config = null) => {
		const [sortConfig, setSortConfig] = React.useState(config);

		const sortedItems = React.useMemo(() => {
			let sortableItems = [...sortedThemes];
			if (sortConfig !== null) {
				sortableItems.sort((a, b) => {
					if (a[sortConfig.key] < b[sortConfig.key]) {
						return sortConfig.direction === 'ascending' ? -1 : 1;
					}
					if (a[sortConfig.key] > b[sortConfig.key]) {
						return sortConfig.direction === 'ascending' ? 1 : -1;
					}
					return 0;
				});
			}
			return sortableItems;
		}, [sortedThemes, sortConfig]);

		const requestSort = (key) => {
			let direction = 'descending';
			if (
				sortConfig &&
				sortConfig.key === key &&
				sortConfig.direction === 'descending'
			) {
				direction = 'ascending';
			}
			setSortConfig({ key, direction });
		};

		return { sortedThemes: sortedItems, requestSort, sortConfig };
	};

	const { sortedThemes, requestSort, sortConfig } = useSortableData(themeSet);

	const getClassNamesFor = (name) => {
		if (!sortConfig) {
			return;
		}
		return sortConfig.key === name ? sortConfig.direction : undefined;
	};

	return (
		<div>
			<div className="themes-page-container">
				<Row style={{ marginBottom: '1rem' }}>
					<Column small={12}>
						<Column
							small={12}
							medium={8}
							style={{ paddingLeft: 0 }}
						>
							<h2>Themes</h2>
							<div>
								Investigate themes or keywords to determine
								their level of impact. Last updated:
								<select name="date" onChange={changeThemeSet}>
									{Object.keys(props.theme_sets).map(
										(date) => {
											return (
												<option value={date} key={date}>
													{dateToStr(date)}
												</option>
											);
										}
									)}
								</select>
							</div>
						</Column>
						<Column
							small={12}
							medium={4}
							style={{ paddingLeft: 0 }}
						>
							<div className="search-bar">
								<FaSearch
									className="search-bar-icon"
									size={16}
								/>
								<input
									type="text"
									placeholder="Search..."
									onChange={(event) => {
										changeSearchTerm(event.target.value);
									}}
								/>
							</div>
						</Column>
					</Column>
				</Row>

				<Row>
					<Column medium={9} small={12}>
						<div className="theme-container">
							<div className="headers-container">
								<button
									id="name-btn"
									type="button"
									onClick={() => requestSort('name')}
									className={getClassNamesFor('name')}
								>
									Events and Themes
								</button>
								<button
									id="engagement-score-btn"
									type="button"
									onClick={() =>
										requestSort('engagement_score')
									}
									className={getClassNamesFor(
										'engagement_score'
									)}
								>
									Engagement
								</button>
								<button
									id="opportunity-score-btn"
									type="button"
									onClick={() =>
										requestSort('opportunity_score')
									}
									className={getClassNamesFor(
										'opportunity_score'
									)}
								>
									Opportunity
								</button>
								<button
									id="location-btn"
									type="button"
									onClick={() => requestSort('location')}
									className={getClassNamesFor('location')}
								>
									Country
								</button>
							</div>

							{sortedThemes
								.filter((theme) => {
									if (
										searchTerm === '' ||
										theme.name
											.toLowerCase()
											.includes(searchTerm.toLowerCase())
									) {
										return theme;
									}
								})
								.map((theme) => {
									if (theme.id === curTheme.id) {
										curThemeRendered = true;
										return (
											<Theme
												id="before-gauge"
												key={theme.id}
												theme={theme}
												active={
													theme.id === curTheme.id
												}
												myOnClick={setTheme}
												mask_content={
													props.mask_content
												}
											/>
										);
									}
									return (
										<Theme
											id={
												curThemeRendered
													? 'after-gauge'
													: 'before-gauge'
											}
											key={theme.id}
											theme={theme}
											active={theme.id === curTheme.id}
											myOnClick={setTheme}
											mask_content={props.mask_content}
										/>
									);
								})}

							{/* mobile only */}
							<div
								id="gauge"
								className="card gauge-container mobile columns small-12 medium-3"
							>
								<EngagementGauge
									curTheme={curTheme}
									colors={gaugeColors}
								/>
								<OpportunityGauge
									curTheme={curTheme}
									colors={gaugeColors}
									mask_content={props.mask_content}
								/>
								<a
									href="https://www.sponsorpulse.com/"
									target="_blank"
									className="purchase-button hollow sponsor-pulse-button"
								>
									<img
										src={SponsorPulseLogo}
										alt="SponsorPulse"
										style={{
											width: '40px',
											height: '40px',
										}}
									/>
									<div className="sponsor-pulse-text purchase-button hollow">
										<p className="body-font">
											Download the complete reports at
											Sponsor Pulse.
										</p>
									</div>
								</a>
								<EngagementGauge
									curTheme={curTheme}
									colors={gaugeColors}
								/>
								<OpportunityGauge
									curTheme={curTheme}
									colors={gaugeColors}
									mask_content={props.mask_content}
								/>
							</div>
							{/* end mobile only */}
						</div>
					</Column>
					<div
						className="columns small-12 medium-3 medium-only"
						style={{ height: 'inherit' }}
					>
						<a
							href="https://www.sponsorpulse.com/"
							target="_blank"
							className="purchase-button hollow sponsor-pulse-button"
						>
							<img
								src={SponsorPulseLogo}
								alt="SponsorPulse"
								style={{ width: '40px', height: '40px' }}
							/>
							<div className="sponsor-pulse-text">
								<p className="body-font">
									Download the complete reports at Sponsor
									Pulse.
								</p>
							</div>
						</a>
						<div className="card sticky gauge-container medium-only">
							<EngagementGauge
								curTheme={curTheme}
								colors={gaugeColors}
							/>
							<OpportunityGauge
								curTheme={curTheme}
								colors={gaugeColors}
								mask_content={props.mask_content}
							/>
						</div>
					</div>
				</Row>
			</div>
		</div>
	);
};

export default ThemesTab;
